export default __webpack_public_path__ + "static/media/haifutong.0e8080a2.png";